import {AfterViewInit, Component}             from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {MatDialogRef}                         from '@angular/material/dialog';
import * as Leaflet                           from 'leaflet';
import {UserPreferencesService}               from '../../services/user-preferences.service';

@Component({
    selector: 'app-user-preferences',
    templateUrl: './user-preferences.component.html',
    styleUrls: ['./user-preferences.component.css']
})
export class UserPreferencesComponent implements AfterViewInit
{
    public userPreferencesForm: UntypedFormGroup;
    private map;
    private latestMarker;
    public pin_dimensions_x: number = 35;
    public pin_dimensions_y: number = 64;

    public constructor(
        public userPreferencesModal: MatDialogRef<UserPreferencesComponent>,
        public fb: UntypedFormBuilder,
        private userPreferncesService: UserPreferencesService
    )
    {
        this.userPreferencesForm = this.fb.group({
            pin_dimensions_x: [35],
            pin_dimensions_y: [64]
        });
    }

    public ngAfterViewInit(): void
    {
        this.initMap();
    }

    public onSubmit(): void
    {
        // TODO: Migrate this over to the preferences service
        localStorage.setItem('userPreferences', JSON.stringify(this.userPreferencesForm.value));
        this.userPreferencesModal.close();
    }

    public initMap(): void
    {
        this.map = Leaflet.map('mapPref', {
            crs: Leaflet.CRS.Simple,
            center: [3309, 2339],
            attributionControl: false,
            zoomSnap: 0,
            minZoom: -10,
            maxBoundsViscosity: 1.0,
            scrollWheelZoom: false
        });

        const bounds = new Leaflet.LatLngBounds([0, 0], [2339, 3309]);

        Leaflet.imageOverlay('assets/images/defaultMap.jpg', bounds).addTo(this.map);

        this.latestMarker = Leaflet.marker([Number(2339 / 2), Number(3309 / 2)], {
            draggable: false,
            icon: Leaflet.icon({
                iconUrl: 'assets/images/red-pin.png',
                iconSize: [this.pin_dimensions_x, this.pin_dimensions_y],
                iconAnchor: [this.pin_dimensions_x / 2, this.pin_dimensions_y],
            })
        }).addTo(this.map);

        this.map.setView([(2339 / 2), (3309 / 2)], this.map.getBoundsZoom(bounds, true));
    }

    public onTabChanged(event): void
    {
        if (event.index == 1 && this.map == null) {
            this.initMap();
        }
    }

    public formatLabel(value: number): string
    {
        return value + '%';
    }

    public calculatePinSize(event): void
    {
        let multiplier = event.value / 100;
        let x = 70 * multiplier;
        let y = 128 * multiplier;

        this.map.removeLayer(this.latestMarker);
        this.latestMarker = Leaflet.marker([Number(2339 / 2), Number(3309 / 2)], {
            draggable: false,
            icon: Leaflet.icon({
                iconUrl: 'assets/images/red-pin.png',
                iconSize: [x, y],
                iconAnchor: [x / 2, y],
            })
        }).addTo(this.map);

        this.userPreferencesForm.controls['pin_dimensions_x'].setValue(x);
        this.userPreferencesForm.controls['pin_dimensions_y'].setValue(y);
    }
}
